import { Controller } from '@hotwired/stimulus';
import _ from 'lodash';

export default class ProgramsFilterController extends Controller {
  static targets = ['search', 'filter'];

  static values = { pageParam: String, orderParam: String, directionParam: String }

  initialize () {
    this.filterInputChange = _.debounce(this.filterInputChange, 500);
  }

  clearFilters (event) {
    const { filter } = event.target.dataset;
    const src = this.searchTarget.src ? this.searchTarget.src : window.location.href;
    const url = new URL(src);

    this.filterTargets.filter(item => item.name === filter).forEach((item) => {
      if (item.type === 'checkbox') {
        item.checked = false;
      } else if (item.type === 'text') {
        item.value = '';
      }
    });

    url.searchParams.delete(this.pageParamValue);
    url.searchParams.delete(filter);
    this.searchTarget.src = url;
  }

  clearAllFilters () {
    const src = this.searchTarget.src ? this.searchTarget.src : window.location.href;
    const url = new URL(src);
    const params = Array.from(url.searchParams.keys());

    params.filter(item => item !== this.orderParamValue && item !== this.directionParamValue)
      .forEach(param => url.searchParams.delete(param));
    this.filterTargets.forEach((item) => {
      if (item.type === 'checkbox') {
        item.checked = false;
      } else if (item.type === 'text') {
        item.value = '';
      }
    });
    this.searchTarget.src = url;
  }

  filterSelectChange (event) {
    const type = event.target.name;
    const { value } = event.target.dataset;
    const url = this.searchTarget.src ? this.searchTarget.src : window.location.href;

    if (event.target.checked) {
      this.addFilterParam(new URL(url), type, value);
    } else {
      this.removefilterParam(new URL(url), type, value);
    }
  }

  filterInputChange (event) {
    const { value } = event.target;
    const type = event.target.name;
    const url = this.searchTarget.src ? this.searchTarget.src : window.location.href;
    this.addTextFilterParam(new URL(url), type, value);
  }

  pillSelectChange (event) {
    const filter = this.filterTargets.find(item => item.id === event.target.dataset.filterId);

    if (filter) filter.click();
  }

  pillInputChange (event) {
    const filter = this.filterTargets.find(item => item.id === event.target.dataset.filterId);

    if (filter) {
      filter.value = '';
      filter.dispatchEvent(new Event('input'));
    }
  }

  addFilterParam (url, type, value) {
    const { searchParams } = url;
    searchParams.delete(this.pageParamValue);

    if (searchParams.has(type)) {
      searchParams.set(type, `${searchParams.get(type)},${value}`);
    } else {
      searchParams.set(type, value);
    }
    this.searchTarget.src = url;
  }

  addTextFilterParam (url, type, value) {
    const { searchParams } = url;
    searchParams.delete(this.pageParamValue);
    searchParams.set(type, value);
    this.searchTarget.src = url;
  }

  removefilterParam (url, type, value) {
    const { searchParams } = url;
    const values = searchParams.get(type).split(',');

    searchParams.delete(this.pageParamValue);
    values.splice(values.indexOf(value), 1);

    if (values.length === 0) {
      searchParams.delete(type);
    } else {
      searchParams.set(type, values.join(','));
    }
    this.searchTarget.src = url;
  }
}
